
export { stringifyStyle, calcPxNum, calcBorder }

function stringifyStyle(obj) {
  let ss = [];
  for (var name in obj) {
    let value = obj[name];
    if (value == undefined || value === null) continue;
    ss.push(name.replaceAll('_', '-') + ':' + value);
  }
  return ss.join(';');
}

function calcPxNum(v) {
  if (typeof(v) == 'number') {
    return `${v}px`;
  } else if (typeof(v) == 'string') {
    if (!isNaN(Number(v))) v = v + 'px';
    return v;
  } else {
    return undefined;
  }
}

function calcBorder(v, color=undefined) {
  if (typeof(v) == 'number' || !isNaN(Number(v))) {
    return `${v}px solid ${color||'lightgray'}`;
  } else if (typeof(v) == 'string') {
    return color ? `${v} solid ${color}` : v; 
  } else if (typeof(v) == 'object') {
    return `${v.width||0}px ${v.style||'solid'} ${color||v.color||'lightgray'}`;
  } else {
    return undefined;
  }
}